import { SpeedDial } from 'primereact/speeddial';
import { useCallback, useEffect, useState } from "react";
import { Button, Card, Col, Container, Image, Modal, Navbar, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { BiLeftArrowAlt } from "react-icons/bi";
import { FaCheck, FaExternalLinkAlt, FaFolderOpen, FaTimes, FaUpload, FaTrashAlt, FaPencilAlt } from "react-icons/fa";
import { HiArrowLeft } from 'react-icons/hi';
import Loader from "react-js-loader";
import { useMediaQuery } from 'react-responsive';
import { Link, useNavigate, useParams } from "react-router-dom";

import iconDocument from "../../../icons/inspection.png";
import Header from '../../../Layout/Header';
import SidebarMenu from '../../../Layout/SidebarMenu';
import { getEndpointUrl, getTimestamp } from '../../../Utils/Common';
import ModalFinishInspection from '../../FormInspeksi/ModalFinishInspection';
import ModalUnggahFoto from '../../FormInspeksi/ModalUnggahFoto';
import ModalCaptionFoto from './ModalCaptionFoto';
import Moment from 'react-moment';
import 'moment-timezone';

const MainFormInspector = () => {
    const [isLoading, setLoading] = useState(true);

    const navigate = useNavigate();

    const [sidebarVisible, setSidebarVisible] = useState(false);

    const isMobile = useMediaQuery({ query: '(max-width: 600px)' });
    const isTabletOrLaptop = useMediaQuery({ query: '(min-width: 600px)' });

    const { offer_id } = useParams();

    const [accesToken] = useState(JSON.parse(localStorage.getItem('credentials')) || []);

    const [submited, setSubmited] = useState([]);

    const [entryAccu, setEntryAccu] = useState({});
    const [entryCondtioner, setEntryCondtioner] = useState({});
    const [entryCabin, setEntryCabin] = useState({});
    const [entrySuspen, setEntrySuspen] = useState({});
    const [entryExterior, setEntryExterior] = useState({});
    const [entryEngine, setEntryEngine] = useState({});
    const [entryFluida, setEntryFluida] = useState({});
    const [entryDocument, setEntryDocument] = useState({});
    const [entryBan, setEntryBan] = useState({});
    const [entryWiper, setEntryWiper] = useState({});
    const [entryFrame, setEntryFrame] = useState({});
    const [entryPemeriksaan, setEntryPemeriksaan] = useState({});

    const [sections, setSections] = useState([]);

    const [devStatus, setDevStatus] = useState('pending');

    const [unggahFotoDialog, setUnggahFotoDialog] = useState(false);

    const [captionTarget, setCaptionTarget] = useState(null);
    const [captionDialog, setCaptionDialog] = useState(false);

    const [confirmSetStatusDialog, setConfirmSetStatusDialog] = useState(false);

    const [images, setImages] = useState([]);

    const [zoomImage, setZoomImage] = useState(null);

    const [deleteTarget, setDeleteTarget] = useState(null);

    const fetchImages = useCallback(async (id) => {
        fetch(getEndpointUrl() + `/v2/inspector/images/${id}?v=${getTimestamp()}`, {
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`
            })
        }).then(response => response.json()).then(json => {
            if (json.status == 'ok') {
                setImages(json.results || []);
            } else {
                setImages([]);
            }
        }).catch(() => setImages([]));
    }, [accesToken]);

    const handleDeleteImage = useCallback((id) => {
        setDeleteTarget(id);
    }, []);

    const handleWriteCaption = useCallback((image) => {
        setCaptionTarget(image);
        setCaptionDialog(true);
    }, []);

    const confirmDeleteImage = useCallback(async () => {
        if (!deleteTarget) return;

        fetch(getEndpointUrl() + `/v2/inspector/images/${deleteTarget}`, {
            method: 'DELETE',
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`
            })
        }).then(response => response.json()).then(json => {
            if (json.status == 'ok') {
                fetchImages(offer_id);
            }
            setDeleteTarget(null);
        }).catch(() => setDeleteTarget(null));
    }, [accesToken, offer_id, fetchImages, deleteTarget]);

    const fetchData = useCallback(async (id) => {
        setLoading(true);

        fetch(getEndpointUrl() + `/checkpoint/count_all/${id}?v=${getTimestamp()}`, {
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`
            })
        }).then(response => response.json()).then(json => {

            if (json.status == 'ok') {
                setSubmited(json.results);

                setEntryAccu(json.results.filter(item => item.category == 'battery').at(0) || {});
                setEntryCondtioner(json.results.filter(item => item.category == 'air-conditioner').at(0) || {});
                setEntryCabin(json.results.filter(item => item.category == 'interior').at(0) || {});
                setEntrySuspen(json.results.filter(item => item.category == 'suspensions').at(0) || {});
                setEntryExterior(json.results.filter(item => item.category == 'exterior').at(0) || {});
                setEntryEngine(json.results.filter(item => item.category == 'mesin').at(0) || {});
                setEntryFluida(json.results.filter(item => item.category == 'fluida').at(0) || {});
                setEntryDocument(json.results.filter(item => item.category == 'document').at(0) || {});
                setEntryBan(json.results.filter(item => item.category == 'ban-rem-velg').at(0) || {});
                setEntryWiper(json.results.filter(item => item.category == 'elektrikal-dan-fitur').at(0) || {});
                setEntryFrame(json.results.filter(item => item.category == 'rangka').at(0) || {});
                setEntryPemeriksaan(json.results.filter(item => item.category == 'hasil-pemeriksaan').at(0) || {});
            }

            setLoading(false);
        }).catch(error => {
            setLoading(true);
        });
    }, []);

    const fetchDataSections = useCallback(async (id) => {
        setLoading(true);

        fetch(getEndpointUrl() + `/v2/form_sections?per_page=100&&v=${getTimestamp()}`, {
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`
            })
        }).then(response => response.json()).then(json => {

            if (json.status == 'ok') {
                setSections(json.results?.data);

                fetchData(offer_id);
            }

            setLoading(false);
        }).catch(error => {
            setLoading(true);
        });
    }, []);

    useEffect(() => {
        fetchDataSections(offer_id);
        fetchData(offer_id);
        fetchImages(offer_id);

    }, [offer_id]);

    useEffect(() => {

    }, [entryAccu, entryCondtioner, entryCabin, entrySuspen, entryExterior, entryEngine, entryFluida, entryDocument, entryBan, entryWiper, entryFrame]);

    const getColorEntry = (entry, totalCheck) => {
        if (Object.keys(entry).length) {
            if (entry.totalEntry < totalCheck) {
                return 'warning';
            } else {
                return 'success';
            }
        }
        return 'secondary';
    }

    const onCallback = useCallback((e) => {
        fetchImages(offer_id);
    }, [offer_id, fetchImages]);

    return (
        <>
            <Helmet>
                <title>Form Inspeksi Kendaraan</title>
            </Helmet>
            <div className="d-block d-sm-none">
                <Navbar expand="lg" className="mainNavbar border-bottom mb-3" sticky="top">
                    <a href="#" onClick={() => navigate(-1)} className="navBackMenu">
                        <HiArrowLeft />
                    </a>
                    <strong className="me-auto navTitle">Form Inspeksi Kendaraan</strong>
                    <Navbar.Toggle className="d-block d-sm-none me-3" onClick={(e) => setSidebarVisible(true)} />
                </Navbar>
                <div className="fixed-bottom">
                    <SpeedDial model={[
                        {
                            label: 'Selesaikan Inspesi',
                            icon: 'pi pi-check',
                            command: () => {
                                setDevStatus('selesai');
                                setConfirmSetStatusDialog(true);
                            }
                        },
                        {
                            label: 'Batalkan Inspesi',
                            icon: 'pi pi-times',
                            command: () => {
                                setDevStatus('cancel');
                                setConfirmSetStatusDialog(true);
                            }
                        },
                        {
                            label: 'Lihat Hasil Inspeksi',
                            icon: 'pi pi-external-link',
                            command: () => navigate(`/inspector/detil/${offer_id}`)
                        }
                    ]} radius={80} type="quarter-circle" direction="up-left" style={{ right: 30, bottom: 30 }} buttonClassName="p-button-secondary" />
                </div>
            </div>
            <SidebarMenu show={sidebarVisible} close={(e) => setSidebarVisible(false)} />
            <div className="d-none d-sm-inline">
                <Header />
            </div>
            <Container className="mt-4 mb-5">
                <div className="d-none d-sm-inline">
                    <Row className="mb-4">
                        <Col md={12} className="mb-3">
                            <strong className="me-auto navTitle">Form Inspeksi</strong>
                        </Col>
                        <Col md={12}>
                            <Button variant="secondary" onClick={() => navigate(-1)} className="pe-3"><BiLeftArrowAlt /> Kembali</Button>
                            <Button variant="outline-secondary" onClick={() => navigate(`/inspector/detil/${offer_id}`)} className="ms-3 pe-3">Lihat Hasil Inspeksi <FaExternalLinkAlt className="ms-2" /></Button>
                            <Button variant="outline-success" onClick={() => {
                                setDevStatus('selesai');
                                setConfirmSetStatusDialog(true);
                            }} className="ms-3 pe-3"><FaCheck /> Selesaikan Inspeksi </Button>
                            <Button variant="outline-danger" onClick={() => {
                                setDevStatus('cancel');
                                setConfirmSetStatusDialog(true);
                            }} className="ms-3 pe-3"><FaTimes /> Batalkan Inspeksi </Button>
                        </Col>
                    </Row>
                </div>
                {isLoading ?
                    <div className="text-center mt-5">
                        <Loader type="bubble-scale" bgColor={"#EF9A9A"} size={100} />
                    </div> :
                    <Row>
                        {sections.map((section, index) => (
                            <Col lg={3} md={4} sm={4} xs={6} key={section.id}>
                                <div className="d-grid gap-2 mb-3">
                                    <Link to={`/inspector/${offer_id}/${section.id}`} className={`btn btn-outline-${getColorEntry(submited.filter(item => item.category == section.id)?.at(0) || {}, section?.form_elements)} btn-lg`}>
                                        <div className="d-flex justify-content-center">
                                            <Image src={process.env.REACT_APP_API_URL + `/images/icons/${section.icon}`} alt={section.title} height={60} />
                                        </div>
                                        <div className="mt-2">{submited.filter(item => item.category == section.id)?.at(0)?.totalEntry || 0}/{section?.form_elements}</div>
                                        <div>{section.title}</div>
                                    </Link>
                                </div>
                            </Col>
                        ))}
                        <Col lg={3} md={4} sm={4} xs={6}>
                            <div className="d-grid gap-2 mb-3">
                                <Link to={`/inspeksi/${offer_id}/hasil-pemeriksaan`} className={`btn btn-outline-${getColorEntry(entryPemeriksaan, 7)} btn-lg`}>
                                    <div className="d-flex justify-content-center">
                                        <Image src={iconDocument} width={60} />
                                    </div>
                                    <div className="mt-2">{entryPemeriksaan.totalEntry}/7</div>
                                    <div>Hasil Pemeriksaan</div>
                                </Link>
                            </div>
                        </Col>
                        {/* <Col lg={3} md={4} sm={4} xs={6}>
                            <div className="d-grid gap-2 mb-3">
                                <Link to={`/inspeksi/${offer_id}/elektrikal-dan-fitur`} className={`btn btn-outline-${getColorEntry(entryWiper, 41)} btn-lg`}>
                                    <div className="d-flex justify-content-center">
                                        <Image src={iconWiper} width={60} />
                                    </div>
                                    <div className="mt-2">{Object.keys(entryWiper).length ? entryWiper.totalEntry : 0}/41</div>
                                    <div>Elektrikal dan Fitur</div>
                                </Link>
                            </div>
                        </Col>
                        <Col lg={3} md={4} sm={4} xs={6}>
                            <div className="d-grid gap-2 mb-3">
                                <Link to={`/inspeksi/${offer_id}/interior`} className={`btn btn-outline-${getColorEntry(entryCabin, 39)} btn-lg`}>
                                    <div className="d-flex justify-content-center">
                                        <Image src={iconCabin} width={60} />
                                    </div>
                                    <div className="mt-2">{Object.keys(entryCabin).length ? entryCabin.totalEntry : 0}/39</div>
                                    <div>Interior</div>
                                </Link>
                            </div>
                        </Col>
                        <Col lg={3} md={4} sm={4} xs={6}>
                            <div className="d-grid gap-2 mb-3">
                                <Link to={`/inspeksi/${offer_id}/mesin`} className={`btn btn-outline-${getColorEntry(entryEngine, 9)} btn-lg`}>
                                    <div className="d-flex justify-content-center">
                                        <Image src={iconEngine} width={60} />
                                    </div>
                                    <div className="mt-2">{Object.keys(entryEngine).length ? entryEngine.totalEntry : 0}/9</div>
                                    <div>Mesin</div>
                                </Link>
                            </div>
                        </Col>
                        <Col lg={3} md={4} sm={4} xs={6}>
                            <div className="d-grid gap-2 mb-3">
                                <Link to={`/inspeksi/${offer_id}/fluida`} className={`btn btn-outline-${getColorEntry(entryEngine, 9)} btn-lg`}>
                                    <div className="d-flex justify-content-center">
                                        <Image src={iconFluida} width={60} />
                                    </div>
                                    <div className="mt-2">{Object.keys(entryFluida).length ? entryFluida.totalEntry : 0}/9</div>
                                    <div>Fluida</div>
                                </Link>
                            </div>
                        </Col>
                        <Col lg={3} md={4} sm={4} xs={6}>
                            <div className="d-grid gap-2 mb-3">
                                <Link to={`/inspeksi/${offer_id}/air-conditioner`} className={`btn btn-outline-${getColorEntry(entryCondtioner, 5)} btn-lg`}>
                                    <div className="d-flex justify-content-center">
                                        <Image src={iconCondtioner} width={60} />
                                    </div>
                                    <div className="mt-2">{Object.keys(entryCondtioner).length ? entryCondtioner.totalEntry : 0}/5</div>
                                    <div>Pendingin / AC</div>
                                </Link>
                            </div>
                        </Col>
                        <Col lg={3} md={4} sm={4} xs={6}>
                            <div className="d-grid gap-2 mb-3">
                                <Link to={`/inspeksi/${offer_id}/battery`} className={`btn btn-outline-${getColorEntry(entryAccu, 1)} btn-lg`}>
                                    <div className="d-flex justify-content-center">
                                        <Image src={iconAccu} width={60} />
                                    </div>
                                    <div className="mt-2">{Object.keys(entryAccu).length ? entryAccu.totalEntry : 0}/1</div>
                                    <div>Battery / AKI</div>
                                </Link>
                            </div>
                        </Col>
                        <Col lg={3} md={4} sm={4} xs={6}>
                            <div className="d-grid gap-2 mb-3">
                                <Link to={`/inspeksi/${offer_id}/exterior`} className={`btn btn-outline-${getColorEntry(entryExterior, 33)} btn-lg`}>
                                    <div className="d-flex justify-content-center">
                                        <Image src={iconExterior} width={60} />
                                    </div>
                                    <div className="mt-2">{Object.keys(entryExterior).length ? entryExterior.totalEntry : 0}/33</div>
                                    <div>Exterior</div>
                                </Link>
                            </div>
                        </Col>
                        <Col lg={3} md={4} sm={4} xs={6}>
                            <div className="d-grid gap-2 mb-3">
                                <Link to={`/inspeksi/${offer_id}/rangka`} className={`btn btn-outline-${getColorEntry(entryFrame, 6)} btn-lg`}>
                                    <div className="d-flex justify-content-center">
                                        <Image src={iconFrame} width={60} />
                                    </div>
                                    <div className="mt-2">{Object.keys(entryFrame).length ? entryFrame.totalEntry : 0}/6</div>
                                    <div>Frame / Rangka</div>
                                </Link>
                            </div>
                        </Col>
                        <Col lg={3} md={4} sm={4} xs={6}>
                            <div className="d-grid gap-2 mb-3">
                                <Link to={`/inspeksi/${offer_id}/suspensions`} className={`btn btn-outline-${getColorEntry(entrySuspen, 10)} btn-lg`}>
                                    <div className="d-flex justify-content-center">
                                        <Image src={iconSuspen} width={60} />
                                    </div>
                                    <div className="mt-2">{Object.keys(entrySuspen).length ? entrySuspen.totalEntry : 0}/10</div>
                                    <div>Suspensi / Kaki-kaki</div>
                                </Link>
                            </div>
                        </Col>
                        <Col lg={3} md={4} sm={4} xs={6}>
                            <div className="d-grid gap-2 mb-3">
                                <Link to={`/inspeksi/${offer_id}/ban-rem-velg`} className={`btn btn-outline-${getColorEntry(entryBan, 10)} btn-lg`}>
                                    <div className="d-flex justify-content-center">
                                        <Image src={iconBan} width={60} />
                                    </div>
                                    <div className="mt-2">{Object.keys(entryBan).length ? entryBan.totalEntry : 0}/10</div>
                                    <div>Ban, Rem, Velg</div>
                                </Link>
                            </div>
                        </Col> */}

                    </Row>
                }
                <Row>
                    <Col>
                        <div className="d-flex justify-content-between my-4">
                            <div>
                                <h6>Foto Hasil Temuan Inspeksi</h6>
                            </div>
                            <div>
                                <Button variant="outline-secondary" onClick={() => setUnggahFotoDialog(true)} className="ms-3 pe-3"><FaUpload className="me-2" /> Unggah Foto</Button>
                            </div>
                        </div>
                        {/* If empty foto inspection */}
                        {images.length === 0 && (
                            <div className='my-4'>
                                <div className="alert alert-secondary text-center" role="alert">
                                    <div>
                                        <FaFolderOpen className="fs-2 text-muted" />
                                    </div>
                                    <p className='mt-3 pb-0'>
                                        Belum ada foto inspeksi apapun disini. Silahkan ungah foto inspeksi.
                                    </p>
                                </div>
                            </div>
                        )}
                        {/* End if empty foto inspection */}
                        {/* If not empty foto inspection */}
                        {images.length > 0 && (
                            <div className='my-4'>
                                <Row xs={2} md={3} lg={4} className="g-3">
                                    {images.map((img) => (
                                        <Col key={img.id}>
                                            <Card>
                                                <Card.Img
                                                    variant="top"
                                                    src={getEndpointUrl() + img.file_path}
                                                    style={{ height: '160px', objectFit: 'cover', cursor: 'pointer' }}
                                                    onClick={() => setZoomImage(getEndpointUrl() + img.file_path)}
                                                />
                                                <Card.Body className="p-2">
                                                    <Card.Text className="text-truncate small mb-1" title={img.original_filename}>
                                                        {img.original_filename}
                                                    </Card.Text>
                                                    <Card.Text className="text-black-50 fst-italic mb-1" title={img.caption}>
                                                        {img.caption}
                                                    </Card.Text>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <small className="text-muted">
                                                            <Moment format="DD/MM/YYYY - HH:mm A">{img.uploaded_at}</Moment>
                                                        </small>
                                                        <div className="d-flex gap-2">
                                                            <Button variant="outline-primary" size="sm" title="Tulis Caption" onClick={() => handleWriteCaption(img)}>
                                                                <FaPencilAlt />
                                                            </Button>
                                                            <Button variant="outline-danger" size="sm" title="Hapus Foto" onClick={() => handleDeleteImage(img.id)}>
                                                                <FaTrashAlt />
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    ))}
                                </Row>
                            </div>
                        )}
                        {/* End if not empty foto inspection */}
                    </Col>
                </Row>
            </Container>
            <ModalUnggahFoto param={offer_id} onCallback={(e) => onCallback(e)} show={unggahFotoDialog} close={() => setUnggahFotoDialog(false)} />
            <ModalCaptionFoto image={captionTarget} onCallback={(e) => onCallback(e)} show={captionDialog} close={() => setCaptionDialog(false)} />
            <ModalFinishInspection param={offer_id} onCallback={(e) => onCallback(e)} show={confirmSetStatusDialog} close={() => setConfirmSetStatusDialog(false)} status={devStatus} />

            {/* Modal zoom foto */}
            <Modal show={!!zoomImage} onHide={() => setZoomImage(null)} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Pratinjau Foto</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    {zoomImage && <Image src={zoomImage} fluid />}
                </Modal.Body>
            </Modal>

            {/* Modal konfirmasi hapus */}
            <Modal show={!!deleteTarget} onHide={() => setDeleteTarget(null)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Konfirmasi Hapus</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="text-center py-2">
                        <FaTrashAlt className="fs-1 text-danger mb-3" />
                        <p className="mb-0">Apakah Anda yakin ingin menghapus foto inspeksi ini? Tindakan ini tidak dapat dibatalkan.</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setDeleteTarget(null)}>Batal</Button>
                    <Button variant="danger" onClick={confirmDeleteImage}><FaTrashAlt className="me-2" /> Hapus</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default MainFormInspector;
